import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { API_URL } from "./config";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Notifications = ({ searchQuery }) => {
    const navigate = useNavigate();
    const [notificationData, setNotificationData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorLoading, setErrorLoading] = useState(false);
    const [formData, setFormData] = useState({ state: 'F' });

    useEffect(() => {
        const asyncFetch = async () => {
            const userId = localStorage.getItem("UserID");
            try {
                let res = await fetch(`${API_URL}/notification-reci/member/${userId}`, {
                    method: "get",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                let responseJson = await res.json();
                setNotificationData(responseJson);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setErrorLoading(true);
            }
        }

        asyncFetch();
    }, []);

    useEffect(() => {
        const handleUpdateStat = async (e) => {
            const userId = localStorage.getItem("UserID");
            try {
                const response = await fetch(`${API_URL}/members/update/notification/${userId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData),
                });
            } catch (error) {
                console.error('error');
            }
        };

        handleUpdateStat();
    }, [])

    const filteredData = useMemo(() => {
        if (!searchQuery) return notificationData;

        const query = searchQuery.toLowerCase();
        return notificationData.filter(notification =>
            notification.header.toLowerCase().includes(query) ||
            notification.content.toLowerCase().includes(query)
        );
    }, [notificationData, searchQuery]);

    return (
        <div style={styles.container}>
            <div style={styles.headerContainer}>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    <ArrowBackIcon style={styles.backIcon} />
                </button>
                <h4 style={styles.heading}>Notifications</h4>
            </div>

            {loading ? (
                <p style={styles.statusText}>Loading...</p>
            ) : errorLoading ? (
                <p style={styles.statusText}>Connection error, check your network connection</p>
            ) : filteredData.length === 0 ? (
                <p style={styles.statusText}>No notifications found {searchQuery && ` for "${searchQuery}"`}</p>
            ) : (
                <div style={styles.notificationsContainer}>
                    {filteredData.map((notification) => (
                        <div
                            key={notification.id}
                            style={styles.notificationCard}
                        >
                            <h5 style={styles.notificationHeader}>
                                {notification.header}
                            </h5>
                            <p style={styles.notificationContent}>
                                <strong>Notice:</strong> {notification.content}
                            </p>
                            <p style={styles.notificationTime}>
                                Sent On: {notification.date.slice(0, 10)} {notification.time.slice(0, 5)}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        padding: '18px',
        marginBottom: '60px',
        backgroundColor: '#fff',
        minHeight: '100vh'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginBottom: '15px',
        position: 'relative'
    },
    backButton: {
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '50%',
        marginRight: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease',
        ':hover': {
            backgroundColor: '#f0f2f5'
        }
    },
    backIcon: {
        color: '#1a6363',
        fontSize: '28px'
    },
    heading: {
        flex: 1,
        textAlign: 'center',
        fontSize: '19px',
        color: '#1a6363',
        fontWeight: '600',
        margin: 0,
        paddingRight: '52px'
    },
    notificationsContainer: {
        textAlign: 'left',
        justifyContent: 'left',
        width: '100%'
    },
    notificationCard: {
        border: '1px solid #1a6363',
        borderRadius: '10px',
        padding: '15px',
        margin: '10px 0',
        backgroundColor: '#f9f9f9',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    notificationHeader: {
        margin: '0',
        fontSize: '16px',
        color: '#1a6363'
    },
    notificationContent: {
        margin: '5px 0',
        fontSize: '14px',
        color: '#555'
    },
    notificationTime: {
        margin: '5px 0',
        fontSize: '14px',
        color: '#555'
    },
    statusText: {
        textAlign: 'center',
        color: '#1a6363',
        marginTop: '20px'
    }
};

export default Notifications;
